import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Game, Tournament, VolleyballGameTeamStatistic, VolleyballStatisticTypes } from '@mtgame/core';

@Component({
  selector: 'mtg-volleyball-game-statistic',
  templateUrl: './volleyball-game-statistic.component.html',
  styleUrls: [
    '../../game/styles/statistic.scss',
    './volleyball-game-statistic.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolleyballGameStatisticComponent {
  @Input()
  game: Game;
  @Input()
  statistic: VolleyballGameTeamStatistic;
  @Input()
  teamRoute: string|string[];
  @Input()
  competitorTeamRoute: string|string[];
  @Input()
  tournament: Tournament;

  get isLight(): boolean {
    if (this.tournament) {
      return this.tournament.settings.volleyballStatisticType === VolleyballStatisticTypes.light;
    }
    return this.game && this.game.volleyballGameConfig && this.game.volleyballGameConfig.statisticType === VolleyballStatisticTypes.light;
  }
}
